<div *ngIf="version"><b>{{ version }}</b></div>

<span *ngIf="update">
    There is an update...
</span>

<div
  *ngIf="envBadge"
  class="env-badge"
  role="status"
  aria-live="polite"
  [attr.aria-label]="
    envBadgeDevelop ? 'Ambiente não produtivo: Develop' : 'Ambiente não produtivo: Staging'
  "
>
  <span
    class="env-badge__pill"
    [class.env-badge__pill--develop]="envBadgeDevelop"
    [class.env-badge__pill--staging]="envBadgeStaging"
    matTooltip="Este não é o ambiente de produção. Dados e integrações podem diferir do ambiente oficial."
    matTooltipPosition="above"
  >
    <span class="env-badge__dot" aria-hidden="true"></span>
    <span *ngIf="envBadgeDevelop">Develop</span>
    <span *ngIf="envBadgeStaging">Staging</span>
  </span>
  <span class="env-badge__hint" aria-hidden="true">Não use para dados reais de clientes finais</span>
</div>

<!-- Demonstração de teste de modal
<button mat-raised-button color="primary" type="button" (click)="openLeadModal()" style="position: fixed; bottom: 16px; right: 16px; z-index: 2000;">
  Testar Lead (ID 1)
</button> -->

<router-outlet></router-outlet>
